import React, { useState, useCallback } from 'react';
import PropTypes from 'prop-types';

const ButtonsList = ({
    fields: propFields,
    showSubtitle: propShowSubtitle,
    data: propData,
    multiOptions: propMultiOptions,
    currentValue: propCurrentValue,
    onChange: propOnChange
}) => {
    const [datePickerValue, setDatePickerValue] = useState('');

    const getAllStatuses = useCallback(() => {
        return ['new', 'review', 'hold', 'confirmed', 'rejected'];
    }, []);

    const handleOnChange = useCallback((value, title) => {
        propOnChange(value, propData.key);
        if ('datepicker' === propData.name) {
            setDatePickerValue(title);
        }
    }, [propOnChange, propData.key, propData.name]);

    const checkIfAllActive = useCallback((filterValue, key, currentValue) => {
        return (
            'all' === filterValue &&
            'status' === key &&
            3 === currentValue.length &&
            getAllStatuses().every((item) => currentValue.includes(item))
        );
    }, [getAllStatuses]);

    const checkIfNonAllActive = useCallback((filterValue, key, currentValue) => {
        return (
            'all' !== filterValue &&
            'status' === key &&
            3 === currentValue.length &&
            getAllStatuses().every((item) => currentValue.includes(item))
        );
    }, [getAllStatuses]);

    const filters = propFields.find(field => field.key === propData.key);

    return (
        <div className="ButtonsList">
            {propShowSubtitle && (
                <label className="bold subtitle">{filters.label}</label>
            )}

            {(filters.list || []).map((filter, i) => {
                let className;
                const isAllActive = checkIfAllActive(filter.value, filters.key, propCurrentValue);
                const isNonAllActive = checkIfNonAllActive(filter.value, filters.key, propCurrentValue);

                className = isAllActive
                    ? 'roundButton--active'
                    : isNonAllActive
                        ? ''
                        : propMultiOptions
                            ? propCurrentValue.includes(filter.value)
                                ? 'roundButton--active'
                                : ''
                            : filter.value === propCurrentValue ||
                            filter.title === datePickerValue
                                ? 'roundButton--active'
                                : '';

                return (
                    <button
                        key={i}
                        className={`roundButton bold ${className}`}
                        type="button"
                        onClick={() => handleOnChange(filter.value, filter.title)}
                    >
                        {filter.title}
                    </button>
                );
            })}
        </div>
    );
};

ButtonsList.propTypes = {
    fields: PropTypes.array,
    showSubtitle: PropTypes.bool,
    data: PropTypes.object,
    multiOptions: PropTypes.bool,
    currentValue: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
    onChange: PropTypes.func
};

ButtonsList.defaultProps = {
    fields: [],
    showSubtitle: false,
    data: {},
    multiOptions: false,
    currentValue: '',
    onChange: () => {}
};

export default ButtonsList;
